import { render, staticRenderFns } from "./ListItem2Template.vue?vue&type=template&id=1d613992"
import script from "./ListItem2Template.vue?vue&type=script&lang=js"
export * from "./ListItem2Template.vue?vue&type=script&lang=js"
import style0 from "./ListItem2Template.vue?vue&type=style&index=0&id=1d613992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports